import React from 'react'
import { FormattedMessage } from 'react-intl'
import Text from '../../Text'

const PurchasePowerTeaserText = props => (
  <Text.Headline {...props}>
    <FormattedMessage
      id='PurchasePowerTeaser.headline'
      defaultMessage='Purchasing power for trade up or investment properties'
    />
  </Text.Headline>
)

export default PurchasePowerTeaserText
